import styles from './WebAgentDialog.module.css'
import renderImage from '../../../source/importImg'

const CloseIcon = ({ onClick }) => (
    <img
        className={styles.closeIcon}
        src="data:image/png;base64,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"
        alt="Close"
        onClick={onClick}
    />
)

const Header = ({ title }) => (
    <div className={styles.header}>
        <h2>{title}</h2>
    </div>
)

const Illustration = () => (
    <div className={styles.icon}>
        <img src={renderImage('webAgent_illustration')} alt="Web Agent Illustration" />
    </div>
)

const WebAgentDialog = ({
    isOpen,
    onInstall,
    onStop,
    onCancel,
    isInstalling,
    isAgentConnected,
}) => {
    if (!isOpen) return null
    const renderConnectedView = () => (
        <>
            <Header title="PLODE Web Agent Status" />

            <div className={styles.content}>
                <Illustration />

                <p className={styles.message}>Web Agent is already running and connected!</p>
                <p className={styles.description}>
                    Your PLODE Web Agent is active and ready to communicate with your device.
                </p>

                <div className={styles.actions}>
                    <button className={styles.installButton} onClick={onCancel}>OK</button>
                </div>
            </div>
        </>
    )
    const renderNotInstalledView = () => (
        <>
            <p className={styles.message}>PLODE Web Agent is not running on your computer.</p>

            <p className={styles.description}>
                The Web Agent is required to communicate with your device and update SD card files.
            </p>

            <div className={styles.actions}>
                <button className={styles.installButton} onClick={onInstall}>
                    Download & Install Agent
                </button>
                <button className={styles.cancelButton} onClick={onCancel}>
                    Cancel
                </button>
            </div>
        </>
    )
    const renderInstallingView = () => (
        <>
            <p className={styles.message}>
                {isAgentConnected ? 'Web Agent Connected!' : 'Waiting for Web Agent...'}
            </p>

            {!isAgentConnected && (
                <>
                    <div className={styles.installInstructions}>
                        <p className={styles.instructionTitle}>Installation Steps:</p>
                        <ol className={styles.instructionList}>
                            <li>Download will start automatically</li>
                            <li>Open the downloaded installer file</li>
                            <li>Follow the installation wizard</li>
                            <li>Launch PLODE Web Agent after installation</li>
                        </ol>
                    </div>

                    <div className={styles.waitingIndicator}>
                        <div className={styles.spinner}></div>
                        <p className={styles.waitingText}>Listening for connection...</p>
                    </div>
                </>
            )}

            <div className={styles.actions}>
                <button className={styles.stopButton} onClick={onStop}>
                    {isAgentConnected ? 'Cancel Operation' : 'Skip / Manual Install'}
                </button>
            </div>
        </>
    )
    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <CloseIcon onClick={onCancel} />
                {!isInstalling
                    ? (
                        !isAgentConnected
                            ? (
                                <>
                                    <Header title="PLODE Web Agent Required" />
                                    <div className={styles.content}>
                                        <Illustration />
                                        {renderNotInstalledView()}
                                    </div>
                                </>
                            )
                            : renderConnectedView()
                    )
                    : (
                        <>
                            <Header title="PLODE Web Agent Required" />
                            <div className={styles.content}>
                                <Illustration />
                                {renderInstallingView()}
                            </div>
                        </>
                    )}
            </div>
        </div>
    )
}

export default WebAgentDialog
